import React, { useState } from "react";
import CustomButton from "../../../../component/elements/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUserType } from "../../../../Redux/Slices/counterSlice";
import CustomPopupForm from "../../../../component/customPopupModel";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import TextFieldCustom from "../../../../component/elements/textfieldCustom";
import { useSnackbar } from "../../../../component/SnackbarContext";
import axiosInstance from "../../../../configuration/request";
import { Popover, Button } from "@mui/material";

function UserTopSection({ canCreate, searchFilter }) {
  const [open, setOpen] = useState(false);
  const [downloadAnchor, setDownloadAnchor] = useState(null); 
  const showSnackbar = useSnackbar();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCreateUser = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleUserSelection = (type) => {
    dispatch(setUserType({ userType: type }));
    setOpen(false);
    navigate("/app/user-management/create-user");
  };

  const handleUserExport = (userType) => {
    axiosInstance
      .get(`/customer/users/user-management?export=true&userType=${userType}` ,{responseType: "blob"})
      .then((response) => {
        // showSnackbar("Download started!", "success");
              const blob = new Blob([response.data], { type: response.headers["content-type"] });
      let filename = "employee.xlsx";
      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) filename = match[1];
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong!",
          "error"
        );
      });
  };

  return (
    <div className="flex justify-between items-center w-full mb-3">
      <div className="flex w-[350px]">
        <TextFieldCustom
          showSearchIcon
          placeholder="Search by email or phone or name"
          customClass={"color-search-textfield"}
          fullWidth
          onChange={(e) => searchFilter(e)}
        />
      </div>

      <div className="flex items-center justify-end">
        {/* Download button */}
        <button
          onClick={(e) => setDownloadAnchor(e.currentTarget)}
          className="flex justify-center items-center h-[45px] w-[45px] rounded-full bg-[#EBF4F9] mr-3 shadow-md transition-all duration-300 hover:bg-[#d6e9f4] hover:shadow-lg hover:scale-105"
        >
          <DownloadOutlinedIcon className="text-[#3383B2]" />
        </button>

        {/* Popover with two options */}
        <Popover
          open={Boolean(downloadAnchor)}
          anchorEl={downloadAnchor}
          onClose={() => setDownloadAnchor(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <div className=" py-3 space-y-2 min-w-[120px]">
            <Button
              className="!font-semibold normal-case"
              variant="text"
              size="small"
              fullWidth
              onClick={() => {
                handleUserExport("business user");
                setDownloadAnchor(null);
              }}
            >
              Business User
            </Button>
            <Button
              className="!font-semibold normal-case"
              variant="text"
              size="small"
              fullWidth
              onClick={() => {
                handleUserExport("delivery user");
                setDownloadAnchor(null);
              }}
            >
              Delivery User
            </Button>
          </div>
        </Popover>

        {/* Create User */}
        {canCreate && (
          <CustomButton
            onClick={handleCreateUser}
            customeClass="gradient-button w-[140px] h-[45px] mr-1"
          >
            <span className="text-xl mr-[4px]">+</span>Create User
          </CustomButton>
        )}
      </div>

      {/* Popup to select user type on create */}
      <CustomPopupForm
        isOpen={open}
        handleClose={handleClose}
        dialogType="user-type-selection"
        userHandler={handleUserSelection}
      />
    </div>
  );
}

export default UserTopSection;
